import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { SupportTicketResponse } from "../../aiTickets.types";
import { ApiRoutesSupportTickets } from "../../constants/enums";
import { UpdateTicketBody } from "./updateTicket.types";

export const requestUpdateTicket = async ({
  ticketId,
  ...body
}: UpdateTicketBody): Promise<SupportTicketResponse> => {
  return await instance.patch(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId),
    body,
  );
};
